import useStore from '@/store'
export function hasAuthority(authority:string|Array<string>): boolean {
  const store = useStore()
  const actions = store.user.actions

  if (!actions || actions.length === 0) {
    return false
  }

  const required: Array<string> = []
  if (authority instanceof String ||
    typeof authority === 'string') {
    required.push(authority as string)
  } else if (authority instanceof Array) {
    required.push(...authority)
  } else {
    throw new Error('(hasAuthority) unsupported parameter type:' + typeof authority)
  }

  if (required.length === 0) {
    return false
  }

  return actions.some(action => {
    return required.includes(action.authorityCode)
  })
}

export function hasRole(role:string|Array<string>) : boolean {
  const store = useStore()
  const roles = store.user.roles

  if (!roles || roles.length === 0) {
    return false
  }

  const required: Array<string> = []
  if (role instanceof String ||
    typeof role === 'string') {
    required.push(role as string)
  } else if (role instanceof Array) {
    required.push(...role)
  } else {
    throw new Error('(hasRole) unsupported parameter type:' + typeof role)
  }

  return roles.some(role => {
    return required.includes(role.roleCode)
  })
}
